import { useParams } from 'react-router-dom';

import { useMutation, useQuery } from '@tanstack/react-query';

import { EQueryKeys } from '../../constants/enums';
import useAxios from '../../hooks/useAxios';
import { BasicPortalSettingsPayload, NewSettingsPayloadData } from '../../views/Builder/types';
import { EApiRoutes, fetchConfig, getApiRouteOrMock } from '../api.utils';

export const usePortalSettings = () => {
  const axios = useAxios();
  const { portalId } = useParams();
  const customHeaders = portalId ? { 'x-portal': portalId } : undefined;

  const getPortalSettingsData = useQuery({
    ...fetchConfig.list,
    queryKey: [EQueryKeys.PORTAL_SETTINGS],
    queryFn: async () => {
      return await axios.get(
        `${getApiRouteOrMock(EApiRoutes.PORTAL_SETTINGS)}`,
        {},
        customHeaders
      );
    }
  });

  const editPortalSettings = useMutation(
    async (newSettingsData: NewSettingsPayloadData) => {
      const response = await axios.put(
        `${getApiRouteOrMock(EApiRoutes.PORTAL_SETTINGS)}`,
        newSettingsData,
        customHeaders
      );
      return response.data;
    },
    {}
  );

  const updateBasicPortalSettings = useMutation(
    async (basicSettingsData: BasicPortalSettingsPayload) => {
      const response = await axios.put(
        `${getApiRouteOrMock(EApiRoutes.PORTAL_SETTINGS)}`,
        basicSettingsData,
        customHeaders
      );
      return response.data;
    },
    {}
  );

  return {
    getPortalSettingsData,
    editPortalSettings,
    updateBasicPortalSettings
  };
};

export default usePortalSettings;
